<!-- Divider -->
<div
    class="hemro-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
